import { render, staticRenderFns } from "./NewsModuleCms.vue?vue&type=template&id=d3b458ea&scoped=true"
import script from "./NewsModuleCms.vue?vue&type=script&lang=ts"
export * from "./NewsModuleCms.vue?vue&type=script&lang=ts"
import style0 from "./NewsModuleCms.vue?vue&type=style&index=0&id=d3b458ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b458ea",
  null
  
)

export default component.exports